import React from 'react';
import Viewer from '../../Viewer';
import { extConfig } from '../../../Editor/presets/Literature/config';
import cn from 'classnames';
import s from './Literature.scss';
const LiteratureViewer = /*#__PURE__*/ React.forwardRef(({ contentJson, className, externalRenderers, cookieType, defaultSize }, ref)=>{
    return /*#__PURE__*/ React.createElement(Viewer, {
        presetId: "literature",
        contentJson: contentJson,
        className: cn(s['root'], className),
        extensionConfig: extConfig,
        externalRenderers: externalRenderers,
        cookieType: cookieType,
        defaultSize: defaultSize,
        ref: ref
    });
});
LiteratureViewer.displayName = 'LiteratureViewer';
export default LiteratureViewer;

//# sourceMappingURL=Literature.js.map